<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.institutions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ mInstitution.name }}
                        </h3>
                    </div>
<b-container>
    <div class="list-group list-group-flush">
        <b-row>
            <b-col col sm="12">
                <div class="list-group-item">
                    {{ $t('message.name') }}:

                    <span class="font-weight-bold">
                                {{ mInstitution.name }}
                            </span>
                </div>
            </b-col>
            <b-col col sm="12">
                <div class="list-group-item">
                    {{ $t('message.description') }}:

                    <div class="font-weight-bold">
                        {{ mInstitution.description }}
                    </div>
                </div>
            </b-col>

            <b-col col sm="12">
                <div class="list-group-item">
                    {{ $t('message.adresse') }}:

                    <div class="font-weight-bold">
                        {{ mInstitution.adresse }}
                    </div>
                </div>
            </b-col>

            <b-col col sm="12">
                <div class="list-group-item">
                    {{ $t('message.logo') }}:

                    <span class="font-weight-bold">
                                <img :src="image" class="card-img-top" alt="Image does not show">
                            </span>
                </div>
            </b-col>
        </b-row>
        <b-row class="justify-content-sm-center" v-if="can || hasAssistante">
            <div class="card-footer text-right">
                <b-button variant="primary" @click="updateInstitution">
                    {{ $t('message.edit') }}
                </b-button>

                <b-button v-b-modal.delete-modal variant="danger">
                    {{ $t('message.delete') }}
                </b-button>
            </div>
        </b-row>
<!--        <div class="list-group-item">-->
<!--            {{ $t('message.createdAt') }}:-->

<!--            <span class="font-weight-bold">-->
<!--                                {{ formattedDate(mInstitution.created_at) }}-->
<!--                            </span>-->
<!--        </div>-->
    </div>
</b-container>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.institutions', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mInstitution.name }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteInstitution">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import AppConfig from '../../constants/AppConfig';


    export default {
        name: "Institution",

        computed: {
            ...mapGetters(["institution",'hasAdminRole',
                'hasGestionnaireRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            mInstitution: function() {
                return this.institution;
            },

            image: function() {
                return AppConfig.imgUrl + '/public/storage/' + this.institution.logo;
            }
        },

        data() {
            return {
                institution_id: this.$route.params.institution
            }
        },

        methods: {
            getInstitution() {
                let args = {
                    institution: this.institution_id
                };

                this.$store.dispatch("getInstitution", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY HH:mm');
            },

            updateInstitution() {
                this.$router.push({ name: 'edit-institution', params: { institution: this.institution_id } });
            },

            deleteInstitution() {
                let self = this;
                let args = {
                    institution: this.institution_id
                };

                let successMessage = this.$i18n.t('message.institutionDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteInstitution', { args, index: self.institution_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            }
        },

        mounted() {
            this.getInstitution();
        }
    }
</script>

<style scoped>

</style>